module.exports = __webpack_public_path__ + "static/media/096.48eb1e06.jpg";